<template>
  <div class="app-header" :class="{ compact: isCompact }">
    <h1>{{ title }}</h1>
    <p v-if="subtitle">{{ subtitle }}</p>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: "",
    },
    isCompact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.app-header {
  text-align: center;
  padding: var(--spacing-lg) 0;
  margin-bottom: var(--spacing-sm);
}

.app-header.compact {
  padding: var(--spacing-sm) 0;
  margin-bottom: var(--spacing-xs);
}

.app-header h1 {
  font-size: var(--font-size-xxl);
  font-weight: 700;
  letter-spacing: -0.5px;
  color: var(--text-color);
  margin-bottom: 5px;
}

.app-header.compact h1 {
  font-size: var(--font-size-xl);
}

.app-header p {
  color: #8a8a8a;
  font-size: var(--font-size-md);
}

.app-header.compact p {
  font-size: var(--font-size-sm);
}
</style>
